import { render } from "./n_ban.vue?vue&type=template&id=e37ae0d2"
const script = {}

import "./n_ban.vue?vue&type=style&index=0&id=e37ae0d2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__